<template>
    <div class="container text-justify">
        <div class="breadcrumb">
            <RouterLink class="breadcrumb-item" :to="{ name: 'home' }">Home</RouterLink>
            <div class="breadcrumb-item">Warum wir inaktive Konten deaktivieren</div>
        </div>

        <h1 class="my-5">Warum wir inaktive Konten deaktivieren</h1>

        <p>
            Die Gründe dafür, inaktive Konten zu deaktivieren, begründen wir dir gerne wie folgt: Bei CANN24 war, ist
            und bleibt es unser Anspruch, unsere Patienten mit relevanten Informationen zu versorgen, auch wenn diese
            gesetzlich nicht gefordert werden. Diese Mehrarbeit erzeugt selbstverständlich auch Kosten auf unserer
            Seite, weshalb wir einfach stärker darauf achten wollen, dass die Informationen den Patienten zuteilwerden,
            die auch aktiv und mindestens in regelmäßigen Abständen unseren Service durch eine entsprechende Versorgung
            in Anspruch nehmen. Gleichzeitig fühlen wir uns aber auch rechtlichen Vorgaben verpflichtet, wenn es um
            Beratung zu verschreibungspflichtigen Arzneimitteln geht. Diese ist in der Apotheke nur dann möglich, wenn
            eine gültige bzw. als aktuell anzusehende ärztliche Verschreibung dazu vorliegt oder vorgelegt werden soll.
            Bei einer längeren Kontoinaktivität von mehr als drei Monaten kann das bei einer leitliniengerechten
            monatlichen Versorgung nicht mehr angenommen werden, weshalb wir uns dazu entschlossen haben, hier mehr
            Augenmerk darauf zu richten als bisher. Selbstverständlich verstehen wir jeden Patienten, der aus
            finanziellen Gründen ein günstigeres Angebot wahrnehmen muss oder möchte. Wenn andere Apotheken diese
            Angebote aber unter anderem auch deshalb darstellen können, weil sie bei Service und Beratung Abstriche
            machen, dann halten wir es auch für angemessen, dass der Patient diese Erfahrung machen muss. Zukünftig
            plant der Gesetzgeber übrigens durch Wiederherstellung der AMPreisV auch wieder eine Gleichpreisigkeit unter
            den Apotheken. Der Wettbewerb findet dann vermutlich nicht mehr über den Preis, sondern über den Service
            statt. Dieser Herausforderung stellen wir uns sehr gerne und selbstbewusst.
        </p>
    </div>
</template>
